import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import { Page } from "../components/Page";
import { isAppV2Enabled } from "./appV2Access";

export const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!isAppV2Enabled) return <Navigate to="/menu" replace />;

  return (
    <Page
      title={t("appV2.home.title")}
      returnButton
      returnButtonAction={() => navigate("/menu")}
    />
  );
};
